/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AtcsShipInfo {
  shipId: string
  aisShipName: string
  targetCode: string
  mmsiCode: string
  callNo: string
  imoCode: string
  shipType: string
  shipLength: number
  shipWidth: number
  shipFlag: string
  /** @format date-time */
  createTime: string
  /** @format date-time */
  updateTime: string
  createChannel: number
  remark: string
  shipOwner: string
  shipOwnerTel: string
  isFocus: boolean
}

export interface AtcsShipDynamic {
  shipId: string
  shipHeading: number
  shipCourse: number
  shipSpeed: number
  longitude: string
  latitude: string
  destination: string
  shipStatus: string
  shipDraught: number
  /** @format date-time */
  preArrivalTime: string
  alarmType: number
  alarmLevel: number
  /** @format date-time */
  updateTime: string
  updateChannel: number
  remark: string
  cacheLongitude: string
  cacheLatitude: string
  currentType: number
  shipinfo: AtcsShipInfo
}

export interface GetShipInfoDto {
  ids: string[]
}

export interface AtcsShipHistory {
  hisId: string
  shipId: string
  shipHeading: number
  shipCourse: number
  shipSpeed: number
  longitude: string
  latitude: string
  destination: string
  shipStatus: string
  shipDraught: number
  /** @format date-time */
  preArrivalTime: string
  alarmType: number
  alarmLevel: number
  /** @format date-time */
  updateTime: string
  updateChannel: number
  remark: string
  cacheLongitude: string
  cacheLatitude: string
  currentType: number
}

export interface GetShipHistoryDto {
  pages: number
  pageSizes: number
}

export interface EfenceVo {
  efenceId: string
  efenceName: string
  efenceLevel: number
  efenceType: number
  efenceIndex: number
  efenceDirection: number
  cssStyle: string
  extendInfo: string
  /** @format date-time */
  createTime: string
  createUser: string
  /** @format date-time */
  updateTime: string
  updateUser: string
  remark: string
  geom: number[][]
}

export interface GetEfenceDto {
  ids: string[]
}

export interface AtcsEquipment {
  equipmentId: string
  datasourceId: string
  equipmentName: string
  equipmentType: number
  equipmentStatus: number
  statusInfo: string
  masterLongitude: string
  masterLatitude: string
  masterDirection: number
  masterAngle: number
  masterPort: number
  slaveLongitude: string
  slaveLatitude: string
  slaveDirection: number
  slaveAngle: number
  slavePort: number
  cssStyle: string
  extendInfo: string
  /** @format date-time */
  lastBeatTime: string
  /** @format date-time */
  createTime: string
  createUser: string
  /** @format date-time */
  updateTime: string
  updateUser: string
  remark: string
  cacheMasterLongitude: string
  cacheMasterLatitude: string
  cacheSlaveLongitude: string
  cacheSlaveLatitude: string
  currentType: number
  showMap: number
}

export interface GetEquipmentDto {
  ids: string[]
}

export interface AtcsEquipmentHis {
  hisId: string
  equipmentId: string
  equipmentStatus: number
  statusInfo: string
  errorCode: string
  /** @format date-time */
  changeTime: string
  remark: string
}

export interface GetEquipmentHisDto {
  pages: number
  pageSizes: number
}

export interface BridgeVo {
  bridgeId: string
  bridgeName: string
  bridgeWidth: number
  bridgeLength: number
  bridgeHeight: number
  bridgeHeightClear: number
  bridgeSpanMin: number
  bridgeSpanMax: number
  bridgeOpeningNum: number
  headLongitude: string
  headLatitude: string
  endLongitude: string
  endLatitude: string
  updateBy: string
  /** @format date-time */
  updateTime: string
  remark: string
  geom: {
    position?: number[]
    length?: number
    width?: number
  }[]
}

export interface GetBridgeDto {
  ids: string[]
}

export interface AtcsWaterLevel {
  levelId: string
  heightCm: number
  heightMm: number
  levelElevation: number
  navigationElevation: number
  /** @format date-time */
  createTime: string
  createUser: string
  /** @format date-time */
  updateTime: string
  updateUser: string
}

export interface GetWaterLevelDto {
  pages: number
  pageSizes: number
}

export type AtcsWind = object

export interface GetWindDto {
  pages: number
  pageSizes: number
}

export type AtcsVisibility = object

export interface GetVisibilityDto {
  pages: number
  pageSizes: number
}

export interface AtcsAlarm {
  alarmId: string
  alarmType: number
  alarmLevel: number
  shipId: string
  efenceId: string
  alarmTimes: number
  dealStatus: number
  dealType: string
  /** @format date-time */
  dealTime: string
  /** @format date-time */
  createTime: string
  /** @format date-time */
  updateTime: string
  remark: string
}

export interface GetAlarmDto {
  pages: number
  pageSizes: number
}

export interface AtcsAlarmNotice {
  noticeId: string
  alarmId: string
  shipId: string
  efenceId: string
  noticeChannel: number
  noticeStatus: number
  /** @format date-time */
  noticeTime: string
  /** @format date-time */
  successTime: string
  /** @format date-time */
  createTime: string
  remark: string
  /** @format date-time */
  failTime: string
  explainFailure: string
}

export interface GetAlarmNoticeDto {
  pages: number
  pageSizes: number
}

export interface VmDeviceLatlng {
  guidDeviceInfo: string
  deviceId: string
  deviceName: string
  idGuidDeviceType: string
  idSim: string
  idRtuId: string
  idBranch: number
  idUsers: string
  idEventtreatment: string
  idWaterroute: number
  alarmSound: string
  alarmLight: string
  /** @format date-time */
  instalDate: string
  notes: string
  timeDgps: string
  xyName: string
  pictureDir: string
  pictureValue: number
  legend: string
  isTransformCoordinate: string
  isCalculateOffset: string
  basePointCoordinates: string
  isBasePoint: string
  voltageHighLevel: string
  voltageLowLevel: string
  currentLevel: string
  calculateOffset: string
  isVoltageAlarm: string
  isCurrentAlarm: string
  latlng: string
  /** @format date-time */
  latlngTimeRec: string
  latitude: number
  longitude: number
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    })
  }
}

/**
 * @title Luckystar Backend
 * @version 0.1
 * @contact
 *
 * 吉星服务
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name AppControllerGetHello
   * @request GET:/
   */
  appControllerGetHello = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/`,
      method: 'GET',
      ...params,
    })

  ship = {
    /**
     * No description
     *
     * @tags ship
     * @name ShipControllerGetDynamicList
     * @summary 动态船只列表
     * @request GET:/ship/dynamicList
     */
    shipControllerGetDynamicList: (
      query?: {
        /** @format date-time */
        after?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AtcsShipDynamic[], any>({
        path: `/ship/dynamicList`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ship
     * @name ShipControllerGetShipInfo
     * @summary 获取船只信息
     * @request POST:/ship/shipInfo
     */
    shipControllerGetShipInfo: (data: GetShipInfoDto, params: RequestParams = {}) =>
      this.request<AtcsShipInfo[], any>({
        path: `/ship/shipInfo`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  shipHistory = {
    /**
     * No description
     *
     * @tags shipHistory
     * @name ShipHistoryControllerGetShipHistoryList
     * @summary 船舶历史动态列表
     * @request GET:/shipHistory/shipHistoryList
     */
    shipHistoryControllerGetShipHistoryList: (params: RequestParams = {}) =>
      this.request<AtcsShipHistory[], any>({
        path: `/shipHistory/shipHistoryList`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags shipHistory
     * @name ShipHistoryControllerGetShipHistory
     * @summary 获取船舶历史动态
     * @request POST:/shipHistory/shipHistory
     */
    shipHistoryControllerGetShipHistory: (data: GetShipHistoryDto, params: RequestParams = {}) =>
      this.request<AtcsShipHistory[], any>({
        path: `/shipHistory/shipHistory`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  efence = {
    /**
     * No description
     *
     * @tags efence
     * @name EfenceControllerGetEfenceList
     * @summary 获取围栏列表
     * @request GET:/efence/list
     */
    efenceControllerGetEfenceList: (params: RequestParams = {}) =>
      this.request<EfenceVo[], any>({
        path: `/efence/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags efence
     * @name EfenceControllerGetEfence
     * @summary 获取围栏信息
     * @request POST:/efence/efence
     */
    efenceControllerGetEfence: (data: GetEfenceDto, params: RequestParams = {}) =>
      this.request<EfenceVo[], any>({
        path: `/efence/efence`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  equipment = {
    /**
     * No description
     *
     * @tags equipment
     * @name EquipmentControllerGetEquipmentList
     * @summary 设备信息列表
     * @request GET:/equipment/equipmentList
     */
    equipmentControllerGetEquipmentList: (params: RequestParams = {}) =>
      this.request<AtcsEquipment[], any>({
        path: `/equipment/equipmentList`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags equipment
     * @name EquipmentControllerGetEquipment
     * @summary 获取设备信息
     * @request POST:/equipment/equipment
     */
    equipmentControllerGetEquipment: (data: GetEquipmentDto, params: RequestParams = {}) =>
      this.request<AtcsEquipment[], any>({
        path: `/equipment/equipment`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  equipmentHis = {
    /**
     * No description
     *
     * @tags equipmentHis
     * @name EquipmentHisControllerGetEquipmentHisList
     * @summary 设备历史列表
     * @request GET:/equipmentHis/equipmentHisList
     */
    equipmentHisControllerGetEquipmentHisList: (params: RequestParams = {}) =>
      this.request<AtcsEquipmentHis[], any>({
        path: `/equipmentHis/equipmentHisList`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags equipmentHis
     * @name EquipmentHisControllerGetEquipmentHis
     * @summary 获取设备历史
     * @request POST:/equipmentHis/equipmentHis
     */
    equipmentHisControllerGetEquipmentHis: (data: GetEquipmentHisDto, params: RequestParams = {}) =>
      this.request<AtcsEquipmentHis[], any>({
        path: `/equipmentHis/equipmentHis`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  bridge = {
    /**
     * No description
     *
     * @tags bridge
     * @name BridgeControllerGetBridgeList
     * @summary 获取桥梁信息列表
     * @request GET:/bridge/list
     */
    bridgeControllerGetBridgeList: (params: RequestParams = {}) =>
      this.request<BridgeVo[], any>({
        path: `/bridge/list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bridge
     * @name BridgeControllerGetBridge
     * @summary 获取桥梁信息
     * @request POST:/bridge/bridge
     */
    bridgeControllerGetBridge: (data: GetBridgeDto, params: RequestParams = {}) =>
      this.request<BridgeVo[], any>({
        path: `/bridge/bridge`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  waterLevel = {
    /**
     * No description
     *
     * @tags waterLevel
     * @name WaterLevelControllerGetWaterLevelList
     * @summary 水位信息列表
     * @request GET:/waterLevel/waterLevelList
     */
    waterLevelControllerGetWaterLevelList: (params: RequestParams = {}) =>
      this.request<AtcsWaterLevel[], any>({
        path: `/waterLevel/waterLevelList`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags waterLevel
     * @name WaterLevelControllerGetWaterLevel
     * @summary 获取水位信息
     * @request POST:/waterLevel/waterLevel
     */
    waterLevelControllerGetWaterLevel: (data: GetWaterLevelDto, params: RequestParams = {}) =>
      this.request<AtcsWaterLevel[], any>({
        path: `/waterLevel/waterLevel`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  wind = {
    /**
     * No description
     *
     * @tags wind
     * @name WindControllerGetWindList
     * @summary 风速风向信息列表
     * @request GET:/wind/windList
     */
    windControllerGetWindList: (params: RequestParams = {}) =>
      this.request<AtcsWind[], any>({
        path: `/wind/windList`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags wind
     * @name WindControllerGetWind
     * @summary 获取风速风向信息
     * @request POST:/wind/wind
     */
    windControllerGetWind: (data: GetWindDto, params: RequestParams = {}) =>
      this.request<AtcsWind[], any>({
        path: `/wind/wind`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  visibility = {
    /**
     * No description
     *
     * @tags visibility
     * @name VisibilityControllerGetVisibilityList
     * @summary 能见度信息列表
     * @request GET:/visibility/visibilityList
     */
    visibilityControllerGetVisibilityList: (params: RequestParams = {}) =>
      this.request<AtcsVisibility[], any>({
        path: `/visibility/visibilityList`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags visibility
     * @name VisibilityControllerGetVisibility
     * @summary 获取能见度信息
     * @request POST:/visibility/visibility
     */
    visibilityControllerGetVisibility: (data: GetVisibilityDto, params: RequestParams = {}) =>
      this.request<AtcsVisibility[], any>({
        path: `/visibility/visibility`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  alarm = {
    /**
     * No description
     *
     * @tags alarm
     * @name AlarmControllerGetAlarmList
     * @summary 预警信息列表
     * @request GET:/alarm/alarmList
     */
    alarmControllerGetAlarmList: (params: RequestParams = {}) =>
      this.request<AtcsAlarm[], any>({
        path: `/alarm/alarmList`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags alarm
     * @name AlarmControllerGetAlarm
     * @summary 获取预警信息
     * @request POST:/alarm/alarm
     */
    alarmControllerGetAlarm: (data: GetAlarmDto, params: RequestParams = {}) =>
      this.request<AtcsAlarm[], any>({
        path: `/alarm/alarm`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  alarmNotice = {
    /**
     * No description
     *
     * @tags alarmNotice
     * @name AlarmNoticeControllerGetAlarmNoticeList
     * @summary 预警通告列表
     * @request GET:/alarmNotice/alarmNoticeList
     */
    alarmNoticeControllerGetAlarmNoticeList: (params: RequestParams = {}) =>
      this.request<AtcsAlarmNotice[], any>({
        path: `/alarmNotice/alarmNoticeList`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags alarmNotice
     * @name AlarmNoticeControllerGetAlarmNotice
     * @summary 获取预警通告
     * @request POST:/alarmNotice/alarmNotice
     */
    alarmNoticeControllerGetAlarmNotice: (data: GetAlarmNoticeDto, params: RequestParams = {}) =>
      this.request<AtcsAlarmNotice[], any>({
        path: `/alarmNotice/alarmNotice`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  deviceDataCors = {
    /**
     * No description
     *
     * @tags deviceDatacores
     * @name DeviceDataCorsControllerGetDatacoresList
     * @summary 获取硬件信息列表
     * @request GET:/device-data-cors/list
     */
    deviceDataCorsControllerGetDatacoresList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/device-data-cors/list`,
        method: 'GET',
        ...params,
      }),
  }
  jxcDevices = {
    /**
     * No description
     *
     * @tags JxcDevices
     * @name JxcDevicesControllerFindAll
     * @summary 浮标设备列表
     * @request GET:/jxc-devices
     */
    jxcDevicesControllerFindAll: (params: RequestParams = {}) =>
      this.request<VmDeviceLatlng[], any>({
        path: `/jxc-devices`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
}
